import { SkilllevelsType } from 'src/shared/types/course';
import { CourseType } from '../types/course';
import { ICourseData } from '../types/course-data';

export const LevelIconSelector = (
  level: SkilllevelsType,
  courseType?: CourseType,
  highlighted?: ICourseData['highlighted'],
) => {
  if (!level) return '';
  if (level === 'per tutti') {
    return '/assets/images/levels/default/tutti.png';
  }
  if (level === 'da zero') {
    return highlighted
      ? '/assets/images/levels/highlighted/mai-suonato.png'
      : '/assets/images/levels/default/mai-suonato.png';
  }

  const courseTypePath = courseType?.toLowerCase();
  const levelMap: Record<Exclude<SkilllevelsType, undefined>, string> = {
    'da zero': 'mai-suonato',
    principiante: 'base',
    intermedio: 'intermedio',
    avanzato: 'avanzato',
    'per tutti': 'tutti',
  };

  const levelPath = levelMap[level];
  return highlighted
    ? `/assets/images/levels/highlighted/${courseTypePath}/${levelPath}.png`
    : `/assets/images/levels/default/${levelPath}.png`;
};
